import type { BranchType, BusinessStatus, LicenseDurationKey, PlannedLicenseType } from '@quds/shared';

export const LICENSE_TYPE_LABELS: Record<PlannedLicenseType, string> = {
  annual: 'Annual',
  monthly: 'Monthly',
  perpetual: 'Perpetual',
  trial: 'Trial',
};

export const DURATION_LABELS: Record<LicenseDurationKey, string> = {
  m1: '1 month',
  m3: '3 months',
  m6: '6 months',
  m12: '12 months',
  m24: '24 months',
  m36: '36 months',
  d14: '14 days',
  d30: '30 days',
};

export const BUSINESS_STATUS_LABELS: Record<BusinessStatus, string> = {
  active: 'Active',
  onboarding: 'Onboarding',
  suspended: 'Suspended',
  inactive: 'Inactive',
};

export const BRANCH_TYPE_LABELS: Record<BranchType, string> = {
  main: 'Main',
  secondary: 'Secondary',
  warehouse: 'Warehouse',
};
